import type { LedgerAdjustmentQueryReqType } from '@/models/types/ledgerAnomaly.types'

// 四支 accounting-adjustment 端點共用同一組查詢條件（egmId／goodsId／startAt／endAt），
// storeId 由後端自登入資訊取得，不進 key
// egmId 省略時用 'all' 當維度，避免與某台名為空字串的機台混淆
const scope = (params: LedgerAdjustmentQueryReqType) =>
  [params.egmId || 'all', params.goodsId ?? '', params.startAt, params.endAt] as const

export const ledgerAnomalyKeys = {
  all: ['ledger-anomaly'] as const,
  abnormal: (params: LedgerAdjustmentQueryReqType) =>
    [...ledgerAnomalyKeys.all, 'abnormal', ...scope(params)] as const,
  record: (params: LedgerAdjustmentQueryReqType) =>
    [...ledgerAnomalyKeys.all, 'record', ...scope(params)] as const,
  correction: (params: LedgerAdjustmentQueryReqType) =>
    [...ledgerAnomalyKeys.all, 'correction', ...scope(params)] as const
}
